import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import Spacer from "./spacer"

const InformationModule = ({ title, description, image, blocks }) => {
  return (
    <div className='container p40 m-p20 ml60'>
      <div className='grid grid-2 mb60 gap-40 bt1 pt40'>
        {title && <h4 className='m0'>{title}</h4>}
        {description && <p className='large m0 nib balance max-550'>{description}</p>}
      </div>
      <div className='grid grid-2 gap-40'>
        <div className='pos-rel'>
          <div className='sticky'>
            <div className='ratio-16-9 w-50 m-100 pos-rel overflow'>
              <GatsbyImage image={image?.gatsbyImageData} alt={title} className='bg-image' />
            </div>
            <Spacer className='m-hide' />
          </div>
        </div>
        <div>
          {blocks?.map(block => (
            <div key={block?.id} className='bt1 pt40'>
              {block?.listItems?.map((item, index, array) => {
                const nextItem = array[index + 1]
                const gap = nextItem?.id?.includes("Subheading") && (item?.id?.includes("Content") || item?.id?.includes("LinkText")) ? "mb40" : "mb20"

                return (
                  <div key={item?.id} className=''>
                    {item?.id?.includes("Subheading") && <p className={`h4 xs m0 ${item?.isLight ? "op-50" : ""} ${gap}`}>{item?.title}</p>}
                    {item?.id?.includes("Content") && (
                      <div
                        className={`nib medium content ul-content balance ${gap}`}
                        dangerouslySetInnerHTML={{
                          __html: item?.content,
                        }}
                      />
                    )}
                    {item?.id?.includes("LinkText") && (
                      <div
                        className={`small content ul-content balance ${gap}`}
                        dangerouslySetInnerHTML={{
                          __html: item?.text,
                        }}
                      />
                    )}
                  </div>
                )
              })}
              <Spacer />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default InformationModule
